<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="data-box">
    <div class="data-item">
      <div class="item1">
        <span><CountUp :to="vocabNum" :duration="1200" /></span>
        <span>词汇量估算</span>
        <span>范围:{{ leveRange }}</span>
      </div>

      <div class="item2">
        <span><CountUp :to="questionNum" :duration="1200" /></span>
        <span>测试题数</span>
        <span>耗时:{{ examTimeDisplay }}</span>
      </div>

      <div class="item3">
        <span><CountUp :to="correctPercent" :duration="1200" suffix="%" /></span>
        <span>总体正确率</span>
        <span>平均反应时间:{{ avgReactionTail }}秒</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed } from "vue";
import CountUp from "./CountUp.vue";

const props = defineProps({
  masteredWord: { type: [String, Number], default: 0 },
  leveRange: { type: String, default: "" },
  questions: { type: [String, Number], default: 0 },
  rightNum: { type: [String, Number], default: undefined },
  examTime: { type: [String, Number], default: undefined },
  examTimeDisplay: { type: String, default: "0秒" },
  rightRate: { type: [String, Number], default: 0 },
  avgReactionTime: { type: String, default: "0" },
});

const safeCountNum = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

const vocabNum = computed(() => Number(props.masteredWord) || 0);
const questionNum = computed(() => Number(props.questions) || 0);

const canComputeCorrectFromCounts = computed(() => {
  const q = safeCountNum(props.questions);
  const r = safeCountNum(props.rightNum);
  return q !== null && q > 0 && r !== null && r >= 0;
});

const correctPercent = computed(() => {
  const rr = props.rightRate;
  if (rr !== undefined && rr !== null && String(rr).trim() !== "") {
    const n = safeCountNum(rr);
    if (n !== null) return n <= 1 && n > 0 ? Math.round(n * 100) : Math.round(n);
    const match = String(rr).match(/\d+/);
    if (match) return Number(match[0]);
  }
  if (canComputeCorrectFromCounts.value) {
    const q = safeCountNum(props.questions);
    const r = safeCountNum(props.rightNum);
    return Math.round((r / q) * 100);
  }
  return 0;
});

/** 平均反应时间数字字符串（秒由模板拼接） */
const avgReactionTail = computed(() => {
  const t = safeCountNum(props.examTime);
  const q = safeCountNum(props.questions);
  if (t !== null && q !== null && q > 0) {
    let avg = t / 1000 / q;
    if (avg < 0.25 && t > 0 && t < 7200) {
      avg = t / q;
    }
    if (avg > 120) {
      avg = t / q;
    }
    return avg.toFixed(avg >= 10 ? 1 : 2);
  }
  return props.avgReactionTime;
});
</script>

<style scoped lang="scss">
.data-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 24px 0 31px;

  .data-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .item1 {
    display: flex;
    flex-direction: column;
    width: 280px;
    height: 134px;
    background: url("@/assets/report/bg1.png") no-repeat center center;
    background-size: 100% 100%;
    padding: 20px 0 0 20px;
    box-sizing: border-box;
    span {
      font-size: 30px;
      color: #a07dff;
    }
    span:nth-child(2) {
      font-weight: 500;
      font-size: 15px;
      color: #8378a0;
      margin: 5px 0;
    }
    span:nth-child(3) {
      font-weight: 400;
      font-size: 13px;
      color: #8378a0;
    }
  }

  .item2 {
    display: flex;
    flex-direction: column;
    width: 280px;
    height: 134px;
    background: url("@/assets/report/bg2.png") no-repeat center center;
    background-size: 100% 100%;
    padding: 20px 0 0 20px;
    box-sizing: border-box;
    span {
      font-size: 30px;
      color: #ff6c86;
    }
    span:nth-child(2) {
      font-weight: 500;
      font-size: 15px;
      color: #986d76;
      margin: 5px 0;
    }
    span:nth-child(3) {
      font-weight: 400;
      font-size: 13px;
      color: #986d76;
    }
  }

  .item3 {
    display: flex;
    flex-direction: column;
    width: 280px;
    height: 134px;
    background: url("@/assets/report/bg3.png") no-repeat center center;
    background-size: 100% 100%;
    padding: 20px 0 0 20px;
    box-sizing: border-box;
    span {
      font-size: 30px;
      color: #ffa061;
    }
    span:nth-child(2) {
      font-weight: 500;
      font-size: 15px;
      color: #ac9270;
      margin: 5px 0;
    }
    span:nth-child(3) {
      font-weight: 400;
      font-size: 13px;
      color: #ac9270;
    }
  }
}
</style>
